import React, { Component } from 'react';

import i18n from 'i18n-react';

import { storageKeys } from 'config/settings.json';
import getFeatureFlags from 'helpers/getFeatureFlags';

import { ContentHeader } from 'components/ContentHeader/ContentHeader';
import RetainGrid from 'components/RetainGrid';
import APIHandler from 'config/APIHandler';
import DataHandler from 'config/DataHandler';
import StorageHandler from 'config/StorageHandler';

const getTotalProgress = (res) => {
  let totalProgress = 0;
  if (res && res.data && res.data[0]) {
    const { chapters } = res.data[0];
    chapters.forEach((chapter) => {
      totalProgress += chapter.progress;
    });
  }
  return totalProgress;
};

const getTotalPages = (res) => {
  let totalPages = 0;
  if (res && res.data && res.data[0]) {
    const { chapters } = res.data[0];
    chapters.forEach((chapter) => {
      totalPages += chapter.total_pages;
    });
  }
  return totalPages;
};

const calculateProgress = (progress, pages) => {
  return Math.round((progress / pages) * 100);
};

export default class TrainingView extends Component {
  constructor(props) {
    super(props);

    this.state = {
      totalprogress_value: 0,
      diploma: 0,
      isAmbassador: false,
    };
  }

  componentDidMount() {
    this.mounted = true;
    void getFeatureFlags().then((flags) => {
      if (this.mounted) {
        this.setState({ isAmbassador: !!flags.ambassador });
      }
    });
  }

  componentWillUnmount() {
    this.mounted = false;
  }

  UNSAFE_componentWillMount() {
    this.getUserInfo();
    if (this.state.totalprogress_value >= 100) {
      this.setState({ diploma: 100 });
    }
  }

  getUserInfo() {
    StorageHandler.load(storageKeys.user).then((res) => {
      if (res) {
        const { email } = res;
        DataHandler.matchAppId().then((appId) => {
          DataHandler.checkKey(storageKeys.progress, APIHandler.getUserProgress(appId, email)).then((userProgress) => {
            const totalProgress = getTotalProgress(userProgress);
            const totalPages = getTotalPages(userProgress);
            const percentage = calculateProgress(totalProgress, totalPages);
            this.setState({ totalprogress_value: percentage });

            if (percentage >= 100) {
              this.setState({ diploma: 100 });
            } else {
              this.setState({ diploma: 0 });
            }
          });
        });
      } else {
        this.setState({ totalprogress_value: 0 });
      }
    });
  }

  render() {
    const { isAmbassador } = this.state;

    return (
      <div className="contentContainer retainView">
        <ContentHeader
          header={i18n.translate('contentHeaders.retain')}
          subtitle={i18n.translate(isAmbassador ? 'pageDescriptions.retainAmbassador' : 'pageDescriptions.retain')}
          pageHeader
        />
        <RetainGrid />
      </div>
    );
  }
}
